export const lst_tipoServicio = [{ id: 1, nombre: "Productos" }, { id: 2, nombre: "Servicios" }]


export const PRODUCTOS = 1;
export const SERVICIOS = 2;
